export const validateRecipeNameServer = (data) => {
  const singleNS = new RegExp(/^[^;,\s]+$/);
  const nameserverFormat = new RegExp(/^(?!https?:\/\/).*(\.[a-zA-Z0-9].*)/);
  const specialChars = new RegExp(/^[0-9a-z.:/_\*-\s\[\]]+$/);
  let ret = null;

  if (data?.length > 0) {
    for (let i in data) {
      const ns = data[i].replaceAll('[', '').replaceAll(']', '');

      if (!specialChars.test(ns)) {
        ret = { valid: false, message: 'Special characters are not allowed.' };
      } else if (!singleNS.test(ns)) {
        ret = {
          valid: false,
          message: 'Please use Enter to separate nameservers.',
        };
      } else if (!nameserverFormat.test(ns)) {
        ret = { valid: false, message: 'Invalid nameserver format.' };
      } else {
        ret = { valid: true };
      }
    }
  } else {
    ret = { valid: false, message: 'Invalid nameserver format.' };
  }

  return ret;
};
